import script from "./Saturation.vue?vue&type=script&setup=true&lang=js"
export * from "./Saturation.vue?vue&type=script&setup=true&lang=js"

import "./Saturation.vue?vue&type=style&index=0&id=5d33dfc6&lang=css"

const __exports__ = script;

export default __exports__